import { Button, CircularProgress, TextField } from "@mui/material";
import { useState } from "react";
import validator from 'validator';
import {login} from '../services/auth';
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import PasswordInput from "../components/PasswordInput";
import '../styles/SignIn.scss';

const SignIn = () => {

  const [email, set_email] = useState('');
  const [password, set_password] = useState('');
  const [is_logging_in, set_is_logging_in] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    set_is_logging_in(true);

    const {data, error} = await login({ email : email, password : password })
    set_is_logging_in(false);
    if(data){
      if(data.success){
        localStorage.setItem('token', data.token);
        navigate('/')
      }else{
        showLoginError();
      }
    }
    if(error){
      showLoginError()
    }
  }

  const showLoginError = () => {
    enqueueSnackbar('Invalid username or password', {
      variant : 'error'
    })
  }

  return(
    <div className="sign-in-page">
      <div className="sign-in-card">
        <img src="/logo.png" alt="Spiritual Tara" className="sign-in-logo" />
        <h1 className="sign-in-heading">Welcome Back</h1>
        <p className="sign-in-subtitle">Sign in to the super admin panel</p>

        <form className="sign-in-form" onSubmit={handleLogin}>
          <TextField
            fullWidth
            variant="outlined"
            label="Email"
            size="medium"
            value={email}
            onChange={(e) => set_email(e.target.value)}
          />

          <PasswordInput
            fullWidth
            variant="outlined"
            label="Password"
            size="medium"
            value={password}
            onChange={(e) => set_password(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disableElevation
            disabled={
              is_logging_in ||
              !validator.isEmail(email) ||
              !Boolean(password)
            }
            sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 700, fontSize: '0.95rem', padding: '12px' }}
          >
            {is_logging_in ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default SignIn;
